export const PAGE_RECORDS_LIMIT = 20;
export const REFRESH_DATA_DEBOUNCE_DELAY = 500; // in milliseconds
